import { render } from "./CardDownloadLink.vue?vue&type=template&id=77fac39c"
import script from "./CardDownloadLink.vue?vue&type=script&lang=js"
export * from "./CardDownloadLink.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__